import { schema } from 'normalizr'

export const dispensationMedicineSchema = new schema.Entity(
  'dispensationMedicines'
)
export const dispensationSchema = new schema.Entity('dispensations', {
  medicines: [dispensationMedicineSchema]
})
